{
  "endTime": "Konečný čas",
  "startTime": "Počáteční čas",
  "time": "Čas"
}
